import React, {Fragment} from 'react'

// Material-UI Core
// import {makeStyles} from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'

// Custom Style
import {advancedSearchFormStyle} from '../../styles/jss/components/fileManager/advancedSearchFormStyle'


// const useStyles = makeStyles(theme => advancedSearchFormStyle(theme))

const SearchFileForm = (props) => {
	// const classes = useStyles()
	const {error, helperText, handleInputChange} = props


	return (
		<Fragment>
			<TextField 
				id="name"
				name="name"
				label="Folder Name"
				required
				autoFocus
				type="text" 
				fullWidth={true} 
				size="small" 
				variant="outlined" 
				onChange={handleInputChange}
				error={error}
				helperText={helperText}
			/>
		</Fragment>
	)
}


export default SearchFileForm